import { render, staticRenderFns } from "./OptionsMenu.vue?vue&type=template&id=6b4c1ef0"
import script from "./OptionsMenu.vue?vue&type=script&lang=js"
export * from "./OptionsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports